import React, { useState } from 'react';
import { pb, authService } from '../services/pocketbase';
import Input from '../components/Input';
import Button from '../components/Button';

const Settings: React.FC = () => {
  const user = pb.authStore.model;
  const [name, setName] = useState(user?.name || '');
  const [username, setUsername] = useState(user?.username || '');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  if (!user) {
    window.location.hash = '#/login';
    return null;
  }

  const handleUpdate = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });
    
    try {
      await authService.updateProfile(user.id, { name, username });
      setMessage({ type: 'success', text: 'Profile updated successfully.' });
    } catch (err: any) {
      setMessage({ type: 'error', text: err.message || 'Update failed.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-6 py-20">
      <h1 className="text-4xl font-black tracking-tighter uppercase text-black mb-12">Settings</h1>
      <div className="bg-white border-2 border-black p-8 md:p-12 shadow-[15px_15px_0px_0px_rgba(249,115,22,1)]">
        {message.text && (
          <div className={`mb-8 p-4 font-black uppercase text-xs border-l-4 ${message.type === 'success' ? 'bg-green-50 text-green-700 border-green-500' : 'bg-orange-50 text-orange-700 border-orange-500'}`}>
            {message.text}
          </div>
        )}
        <form onSubmit={handleUpdate}>
          <div className="space-y-8">
            <Input label="Public Name" value={name} onChange={(e) => setName(e.target.value)} />
            <Input label="Username" value={username} onChange={(e) => setUsername(e.target.value)} />
            <Button variant="primary" isLoading={loading} type="submit">Save Changes</Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Settings;